/* eslint-disable @next/next/no-img-element */
import useTranslation from 'next-translate/useTranslation';

// Components
import Button from '@/components/base/Button';
import Icon from '@/components/base/Icon';
import LinkBase from '@/components/base/LinkBase';

// Hooks
import useWebflowArticles from '@/utils/hooks/swr/useWebflowArticles';

// Types
import type { PlatformLanguagesType } from '@/types/userType';

const NewFeature = () => {
    const { t, lang } = useTranslation('home');

    const { articles, isLoading, articlesError } = useWebflowArticles({
        params: {
            article_types: ['product_update'],
            article_count: 1,
            lang: lang as PlatformLanguagesType
        }
    });

    if (isLoading) return <LoaderSkeleton />;

    if (articlesError || !articles.length) return null;

    const newFeature = articles[0];

    return (
        <div
            className="col-span-4 w-full rounded-md bg-white p-1 @container dark:bg-icoDarkMode-anthracite lg:col-span-2"
            data-testid="new-feature">
            <div className="relative flex h-full w-full flex-col rounded-md bg-white dark:bg-icoDarkMode-anthracite sm:flex-row">
                {newFeature?.image_url ? (
                    <img
                        src={newFeature.image_url}
                        alt={t(newFeature.title)}
                        width={1080}
                        height={413}
                        className="w-full rounded-m object-cover sm:w-1/2"
                    />
                ) : null}
                <div className="mx-5 my-4 flex flex-col">
                    <div className="mb-5 flex items-center space-x-2">
                        <div className="flex items-center space-x-2 rounded-full bg-icoBlue-100 px-2 py-1 text-xs text-icoBlue dark:bg-icoBlue dark:bg-opacity-20">
                            <Icon icon="reports" className="rotate-180" />
                            <p>{t('new_feature.new_feature')}</p>
                        </div>
                    </div>
                    <p className="mb-2 w-full font-GBold text-xl text-icoBlack dark:text-white">
                        {t(newFeature.title)}
                    </p>
                    <p className="mb-5 line-clamp-2 w-full font-GMedium text-xs text-icoGray-500 dark:text-icoDarkMode-wolf">
                        {t(newFeature.content)}
                    </p>
                    <LinkBase href={newFeature.link} target="_blank" className="mt-auto w-min">
                        <Button size="sm" variant="secondary">
                            {t('cta_read_more')}
                        </Button>
                    </LinkBase>
                </div>
            </div>
        </div>
    );
};

const LoaderSkeleton = () => {
    return (
        <div
            className="col-span-4 w-full rounded-md bg-white p-1 @container dark:bg-icoDarkMode-anthracite lg:col-span-2"
            data-testid="loader-skeleton">
            <div className="relative flex h-full w-full flex-col rounded-md bg-white dark:bg-icoDarkMode-anthracite sm:flex-row">
                <div className="w-full animate-pulse rounded-m bg-icoGray-100 dark:bg-icoDarkMode-deepBlack sm:w-1/2"></div>
                <div className="mx-5 my-4 flex w-full flex-col justify-between sm:w-1/2">
                    {[1, 2, 3, 4, 5].map((index) => (
                        <div
                            key={index}
                            className="h-4 w-full animate-pulse bg-icoGray-100 dark:bg-icoDarkMode-deepBlack"></div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default NewFeature;
